module.exports = __webpack_public_path__ + "img/1-2.c939fce8.png";